export { default as HUIModal } from './hui-modal';
export type { HUIModalHeaderProps, HUIModalProps } from './types';
